<template>
  <div class="mt-16">
    <RevInputTextarea
      :id
      v-model="comment"
      data-test="comment-input"
      :error="errorMessage"
      :label="i18n(translations.textareaLabel)"
      :rows="5"
    />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevInputTextarea } from '@ds/components/InputTextarea'

import translations from './QuestionTextarea.translations'

defineProps<{
  id: string
  errorMessage?: string
}>()

const i18n = useI18n()

const comment = defineModel<string>()
</script>
